import ac from 'argument-contracts';

/**
 * Interface Registrars
 *
 * @interface Registrar
 */

/**
 * Register an applet with the registrar
 *
 * @function
 * @name Registrar#register
 * @param {AppletBase} applet - The applet to be registered in the shape of https://github.com/meltwater/applet-base
 * @returns {undefined}
 */

export function isValidRegistrar({ register }) {
    try {
        ac.assertFunction(register);
    } catch (__error) {
        return false;
    }

    return true;
}
